module.exports = __webpack_public_path__ + "b7ef5432464d0d0b0542131097652b84.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-BoldItalic.woff
// module id = 412
// module chunks = 0